<template>
  <span v-if="visible">
    <i-btn
      color="info"
      icon="fa-clone"
      :title="buttonTitle"
      @click="dialog = true"
    />
    <v-dialog v-model="dialog" max-width="700">
      <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
          <v-alert
            v-if="showApparel && !loading && !items.length"
            type="info"
            dense
          >
            Clona primero la prenda global asociada para poder clonar este
            estilo.
          </v-alert>
          <v-text-field
            v-model="search"
            :label="$t('search')"
            append-icon="fa-search"
            outlined
            dense
          />
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            :search="search"
            :loading="loading"
            show-select
            item-key="id"
            :items-per-page="10"
          >
            <template v-if="showImage" v-slot:item.image_path="{ item }">
              <v-img
                v-if="item.image_path"
                :src="item.image_path"
                max-width="32"
                max-height="32"
                class="rounded"
              />
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" :loading="loading" @click="save">
            {{ $tc('save', 1) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CatalogCloneControl',
  props: {
    apiName: { type: String, required: true },
    idsKey: { type: String, required: true },
    title: { type: String, required: true },
    buttonTitle: { type: String, required: true },
    showImage: { type: Boolean, default: false },
    showApparel: { type: Boolean, default: false },
    apparelId: { type: [Number, String], default: null }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      search: '',
      items: [],
      selected: []
    }
  },
  computed: {
    ...mapGetters({
      me: 'session/me',
      company: 'company/getCompanyData'
    }),
    visible() {
      const rawSuperuser = this.me && this.me.is_superuser
      const isSuperuser =
        rawSuperuser === true ||
        rawSuperuser === 1 ||
        ['true', '1'].includes(String(rawSuperuser).toLowerCase())

      return !!this.company && !isSuperuser
    },
    headers() {
      const headers = [{ text: this.$t('name'), value: 'name' }]
      if (this.showApparel) {
        headers.push({
          text: this.$tc('apparel_name', 1),
          value: 'apparel_name'
        })
      }
      if (this.showImage) {
        headers.push({ text: this.$t('image'), value: 'image_path' })
      }
      return headers
    }
  },
  watch: {
    dialog(value) {
      if (value) {
        this.selected = []
        this.loadItems()
      }
    }
  },
  methods: {
    async loadItems() {
      this.loading = true
      try {
        const response = await this.$api.product[this.apiName].list({
          opt: {
            params: {
              global: true,
              no_page: true,
              company_id: this.company && (this.company.pk || this.company.id),
              ...(this.apparelId ? { apparel_id: this.apparelId } : {})
            }
          }
        })
        this.items = response.data.results || response.data || []
      } catch (error) {
        this.$toast.error(this.$t('error_loading_data'))
      } finally {
        this.loading = false
      }
    },
    async save() {
      if (!this.selected.length) {
        this.$toast.warning(this.$t('select_at_least_one'))
        return
      }
      this.loading = true
      try {
        await this.$api.product[this.apiName].clone({
          form: {
            [this.idsKey]: this.selected.map((item) => item.id || item.pk),
            company_id: this.company && (this.company.pk || this.company.id),
            ...(this.apparelId ? { apparel_id: this.apparelId } : {})
          },
          opt: { skipErrorToast: true }
        })
        this.$toast.success(this.$t('saved'))
        this.$emit('done')
        this.dialog = false
      } catch (error) {
        const detail = error.response?.data?.detail
        const message =
          detail === 'clone_apparel_before_style'
            ? this.$t('clone_apparel_before_style')
            : detail || this.$t('error_saving')
        this.$toast.error(message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
